/* eslint-disable */

/** unique or primary key constraints on table "argo.auth_provider_local" */
export enum ArgoAuthProviderLocalConstraint {
  /** unique or primary key constraint on columns "auth_provider_record_id" */
  AuthProviderLocalAuthProviderRecordIdKey = 'auth_provider_local_auth_provider_record_id_key',
  /** unique or primary key constraint on columns "email" */
  AuthProviderLocalEmailKey = 'auth_provider_local_email_key',
  /** unique or primary key constraint on columns "auth_provider_local_id" */
  AuthProviderLocalPkey = 'auth_provider_local_pkey',
  /** unique or primary key constraint on columns "user_id" */
  AuthProviderLocalUserId = 'auth_provider_local_user_id'
}

/** select columns of table "argo.auth_provider_local" */
export enum ArgoAuthProviderLocalSelectColumn {
  /** column name */
  AuthProviderRecordId = 'auth_provider_record_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  FailedAttempts = 'failed_attempts',
  /** column name */
  HasuraRole = 'hasura_role',
  /** column name */
  Id = 'id',
  /** column name */
  LockExpiresAt = 'lock_expires_at',
  /** column name */
  Meta = 'meta',
  /** column name */
  MfaEnabled = 'mfa_enabled',
  /** column name */
  MfaSession = 'mfa_session',
  /** column name */
  OtpSecret = 'otp_secret',
  /** column name */
  PasswordHash = 'password_hash',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** select "argo_auth_provider_local_aggregate_bool_exp_bool_and_arguments_columns" columns of table "argo.auth_provider_local" */
export enum ArgoAuthProviderLocalSelectColumnArgoAuthProviderLocalAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Enabled = 'enabled',
  /** column name */
  MfaEnabled = 'mfa_enabled'
}

/** select "argo_auth_provider_local_aggregate_bool_exp_bool_or_arguments_columns" columns of table "argo.auth_provider_local" */
export enum ArgoAuthProviderLocalSelectColumnArgoAuthProviderLocalAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Enabled = 'enabled',
  /** column name */
  MfaEnabled = 'mfa_enabled'
}

/** update columns of table "argo.auth_provider_local" */
export enum ArgoAuthProviderLocalUpdateColumn {
  /** column name */
  AuthProviderRecordId = 'auth_provider_record_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  FailedAttempts = 'failed_attempts',
  /** column name */
  HasuraRole = 'hasura_role',
  /** column name */
  Id = 'id',
  /** column name */
  LockExpiresAt = 'lock_expires_at',
  /** column name */
  Meta = 'meta',
  /** column name */
  MfaEnabled = 'mfa_enabled',
  /** column name */
  MfaSession = 'mfa_session',
  /** column name */
  OtpSecret = 'otp_secret',
  /** column name */
  PasswordHash = 'password_hash',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

